/* eslint no-nested-ternary: "off" */

import React from 'react';
import PropTypes from 'prop-types';
import { PlusIcon, QuestionMarkCircleIcon } from '@heroicons/react/outline';
import Button from '../../../components/Button';

const ActionCard = ({
  'data-testid': testId,
  title,
  tooltip,
  children,
  isLoading,
  bordered,
  className,
  onAdd,
  onShowHint,
  actions,
}) => {
  return (
    <div
      className={`p-4 bg-surface rounded-md border border-divider stack-4 ${className}`}
    >
      <div className="flex items-center justify-between">
        <p className="font-medium truncate">{title}</p>
        <div className="cluster-2 items-center">
          {onShowHint && (
            <Button
              size="medium"
              type="ghost"
              icon={<QuestionMarkCircleIcon />}
              onClick={onShowHint}
            />
          )}
          {onAdd && (
            <Button
              size="medium"
              type="primary"
              icon={<PlusIcon />}
              onClick={onAdd}
            >
              Add
            </Button>
          )}
          {actions}
        </div>
      </div>
      {title && <hr />}
      {children}
    </div>
  );
};

ActionCard.propTypes = {
  'data-testid': PropTypes.string,
  title: PropTypes.string,
  tooltip: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  isLoading: PropTypes.bool,
  bordered: PropTypes.bool,
};

ActionCard.defaultProps = {
  'data-testid': null,
  title: null,
  tooltip: null,
  isLoading: false,
  className: '',
  bordered: false,
};

export default ActionCard;
